function imageHeightResizer() {
    var heightNavbar = $(".navbar").height() ? $(".navbar").height() : 0;
    var heightContent = $(".js-get-height").height();
    var heightWindow = $(window).height();
    var blockWrapperPaddingTop = parseFloat($(".js-get-height").closest(".block-wrapper").css("padding-top"));
    var blockWrapperPaddingBottom = parseFloat($(".js-get-height").closest(".block-wrapper").css("padding-bottom"));

    $(".image").css("height", heightWindow - (heightContent + heightNavbar + blockWrapperPaddingTop + blockWrapperPaddingBottom));
}

function navbarDropdown(reset) {
    if (!$(".main-menu.navbar").length || $(document).width() < 992) return false;

    if (reset) {
        $(".main-menu .navbar-nav > .nav-item:not(.dropdown)").show();
        $(".main-menu .navbar-nav .dropdown .nav-item").hide();
        $(".main-menu .navbar-nav > .nav-item.dropdown").hide();
    }

    var navbarRect = $(".main-menu.navbar")[0].getBoundingClientRect();
    var rect = $(".navbar-extra-top")[0].getBoundingClientRect();
    var navbarExtraTopHeight = $(".navbar-extra-top").height();
    var navbarExtraTopChildHeight = $(".navbar-extra-top a:visible").first().outerHeight();

    if (navbarExtraTopChildHeight && (navbarExtraTopHeight > navbarExtraTopChildHeight || rect.right + 32 != navbarRect.right)) {
        //hide last child
        var hidenIndex = $(".main-menu .navbar-nav > .nav-item:visible:not(.dropdown)").last().index();
        $(".main-menu .navbar-nav > .nav-item:visible:not(.dropdown)").last().hide();

        $(".main-menu .navbar-nav .dropdown .nav-item").each(function (index) {
            console.log("hidenIndex", hidenIndex, index);
            if (hidenIndex == index) {
                $(this).show();
            }
        });

        $(".main-menu .navbar-nav > .nav-item.dropdown").show();
        navbarDropdown(false);
    }
}

function productCategorySwitch() {
    $(".product-category-switch").click(function () {
        $(".products-view-all").hide();
        $(".product-category-switch").removeClass("active");
        $(this).addClass("active");
        var category = $(this).data("category");
        if ($(this).data("category")) {
            $(".product").hide();
            $('.product[data-category="' + category + '"]').show();
        } else {
            $(".product").show();
        }
    });
}

$(function () {
    $(".products-view-all").click(function () {
        $(this).hide();
        $(".product").show();
    });

    $(".navbar-toggler").click(function () {
        $(this).toggleClass("collapsed");
        $(".navbar-collapse").toggleClass("show");
        $(".navbar").toggleClass("active");
    });

    $(".main-menu .navbar-nav > .nav-item").click(function () {
        $(".navbar-toggler").addClass("collapsed");
        $(".navbar-collapse").removeClass("show");
        $(".navbar").removeClass("active");
    });

    $(".popup .close").click(function () {
        $(this).closest(".popup").fadeOut();
    });

    $(".view-specification-popup").click(function () {
        $(".popup").css("display", "flex").hide().fadeIn();
    });

    if (window.location.hash) {
        var hash = window.location.hash;

        if ($(hash).length) {
            $("html, body").animate(
                {
                    scrollTop: $(hash).offset().top + 250,
                },
                900
            );
        }
    }

    imageHeightResizer();
    navbarDropdown(true);

    productCategorySwitch();
});

$(window).resize(function () {
    imageHeightResizer();
    navbarDropdown(true);
});
